<template>
    <div
        v-if="configs && configs.commenting_submit"
        class="c-career-send-cv"
    >
        <h5 class="c-career-send-cv__title">
            {{ $t('careers.send_cv') }}

            <span class="color-primary-text">{{ $t('careers.cv') }}</span>
        </h5>

        <y-input
            ref="name"
            v-model="model.name"
            name="name"
            class="mt-6"
            :placeholder="$t('fields.name')"
            :validation="configs.commenting_name === 'required' ? 'required' : null"
        />

        <y-input
            ref="email"
            v-model="model.email"
            name="email"
            :placeholder="$t('fields.email')"
            class="mt-6"
            :validation="configs.commenting_email === 'required' ? 'required' : null"
        />

        <y-uploader
            v-if="configs.commenting_attachment !== 'no_receive' && !$wait.is('comment-form-reload')"
            ref="uploader"
            v-model="model.attachment"
            name="attachment"
            :max-file-size="configs.commenting_attachment_max_capacity"
            :accepted-files="configs.commenting_attachment_extensions"
            :max-files="configs.commenting_attachment_max_number"
            :payload="configs.payload"
            linear
            color="primary"
        />

        <y-button
            size="medium"
            :content="$t('careers.apply_for_job')"
            color="primary"
            class="mt-10"
            loading-on="saving-comment"
            block
            flat
            @click.prevent="beforeSubmit"
        />

        <y-recaptcha
            v-if="configs.recaptcha"
            ref="recaptcha"
            :site-key="configs.recaptcha.key"
            :size="configs.recaptcha.size"
            @verify="afterVerify"
        />
    </div>
</template>

<script>
    import { YInput, YUploader, YRecaptcha } from '@groot-components/all';

    export default {
        name: 'SendCV',

        components: {
            YInput,
            YUploader,
            YRecaptcha,
        },

        props: {
            configs: Object,
        },

        /**
         * @inheritdoc
         */
        data() {
            return {
                model: {},
            };
        },

        methods: {
            /**
             * Verify recaptcha
             * Check recaptcha is active
             */
            beforeSubmit() {
                this.$wait.start('saving-comment');
                if (this.configs?.recaptcha?.active === '1') {
                    this.$refs.recaptcha.verify();
                } else {
                    this.save();
                }
            },

            /**
             * Set token and start Sending Comment
             *
             * @param {string} token
             */
            afterVerify(token) {
                this.model['g-recaptcha-response'] = token;
                this.save();
            },

            /**
             * Do send comment
             *
             * @returns {object}
             */
            save() {
                const params = {
                    ...this.model,
                    id  : this.configs.post_id,
                    type: 'hiring',
                };

                return this.$services.Commenting.commentSave(params).then(() => {
                    this.model = {};
                    this.$toast.success(this.$t('careers.success_save_cv'));
                    this.$wait.start('comment-form-reload');
                    this.$refs.name.$children[0].$children[0].reset();
                    this.$refs.email.$children[0].$children[0].reset();
                }).catch((error) => {
                    this.handleError(error);
                }).finally(() => {
                    this.$wait.end('saving-comment');
                    setTimeout(() => {
                        this.$wait.end('comment-form-reload');
                    }, 500);
                    this.$refs.recaptcha.reset();
                });
            },
        },
    };
</script>

<style lang="scss" src="./index.scss" />
